<template>
    <div class="job-filter-wrap d-flex align-center flex-wrap">
        <el-button class="btn theme-btn" @click="isShowFilterSetting = true">
            <el-icon><Filter /></el-icon> Filters
        </el-button>
        <el-input v-model="input4" class="w-100" placeholder="Type something">
            <template #prefix>
                <el-icon><Search /></el-icon>
            </template>
        </el-input>

        <p class="find-job-title">
            Find a job by <router-link to="/companies">companies</router-link>
        </p>


        <el-dialog v-model="isShowFilterSetting" title="Advance Filters">
            <el-form label-position="top" class="job-advanced-filter">
                <div class="job-filter-inner">
                    <h1>Location</h1>
                    <div class="row">
                        <div class="col-md-6">
                            <el-form-item label="Distance">
                                <el-select class="w-full" v-model="distance" filterable clearable placeholder="Select Distance">
                                    <el-option
                                    v-for="item in distanceItems"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-6">
                            <el-form-item label="City">
                                <el-select class="w-full" placement="top" v-model="city" filterable clearable placeholder="Select City">
                                    <el-option
                                    v-for="city in cities"
                                    :key="city.value"
                                    :label="city.label"
                                    :value="city.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="job-filter-inner">
                    <h1>Tech</h1>
                    <div class="row">
                        <div class="col-md-6">
                            <el-form-item label="Tech You Like">
                                <el-input placeholder="e.g javascript"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-md-6">
                            <el-form-item label="Tech You dislike">
                                <el-input placeholder="e.g javascript"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="job-filter-inner">
                    <h1>Compensation</h1>
                    <div class="row">
                        <div class="col-md-6">
                            <el-form-item label="Minimum Annual Salary">
                                <el-input placeholder="e.g 583"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-md-6">
                            <el-form-item label="Currency">
                                <el-select v-model="currency" class="w-full" placeholder="Select Currency" size="large">
                                    <el-option
                                    v-for="item in currencies"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="job-filter-industries">
                        <p class="el-form-item__label">Industries</p>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="industries">
                                    <el-checkbox label="Accounting" size="large" />
                                    <el-checkbox label="Advertising" size="large" />
                                    <el-checkbox label="Aerospace" size="large" />
                                    <el-checkbox label="Agriculture" size="large" />
                                    <el-checkbox label="Architecture" size="large" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="industries">
                                    <el-checkbox label="Arts" size="large" />
                                    <el-checkbox label="Automotive" size="large" />
                                    <el-checkbox label="Customer Service" size="large" />
                                    <el-checkbox label="Data & Analytics" size="large" />
                                    <el-checkbox label="Finance" size="large" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="industries">
                                    <el-checkbox label="Food & Beverage" size="large" />
                                    <el-checkbox label="Gaming" size="large" />
                                    <el-checkbox label="Government" size="large" />
                                    <el-checkbox label="Hardware" size="large" />
                                    <el-checkbox label="Health & Fitness" size="large" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="job-filter-inner">
                    <h1>More</h1>
                    <div class="row">
                        <div class="col-md-6">
                            <el-form-item label="Applications">
                                <el-checkbox label="Be one of the first applicants" size="large" />
                            </el-form-item>
                        </div>
                        <div class="col-md-6">
                            <el-form-item label="Responses">
                                <el-checkbox label="High response rate" size="large" />
                            </el-form-item>
                        </div>
                    </div>
                </div>

                <el-form-ite>
                    <el-button class="btn theme-btn">Search</el-button>
                </el-form-ite>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { Search, Filter } from '@element-plus/icons-vue';


export default {
    name: 'JobsFilter',
    components: {
        Search,
        Filter
    },
    data() {
        return {
            isShowFilterSetting: false,
            distance: '',
            city: '',
            distanceItems: [
                {
                    label: 'Within 5km',
                    value: 'within-5km',
                },
                {
                    label: 'Within 10km',
                    value: 'within-10km',
                },
                {
                    label: 'Within 15km',
                    value: 'within-15km',
                },
                {
                    label: 'Within 20km',
                    value: 'within-20km',
                },
                {
                    label: 'Within 30km',
                    value: 'within-30km',
                },
                {
                    label: 'Within 50km',
                    value: 'within-50km',
                }
            ],
            cities: [
                {
                    label: 'Afghanistan',
                    value: 'AF'
                },
                {
                    label: "Åland Islands",
                    value: 'AX'
                },
                {
                    label: "Albania",
                    value: 'AL'
                },
                {
                    label: "Algeria",
                    value: 'DZ'
                },
                {
                    label: "American Samoa",
                    value: 'AS'
                },
                {
                    label: "Andorra",
                    value: 'AD'
                },
                {
                    label: "Angola",
                    value: 'AO'
                },
                {
                    label: "Anguilla",
                    value: 'AI'
                },
                {
                    label: "Antarctica",
                    value: 'AQ'
                },
                {
                    label: "Antigua and Barbuda",
                    value: 'AG'
                },
                {
                    label: "Argentina",
                    value: 'AR'
                },
                {
                    label: "Armenia",
                    value: 'AM'
                },
                {
                    label: "Aruba",
                    value: 'AW'
                },
                {
                    label: "Australia",
                    value: 'AU'
                },
                {
                    label: "Austria",
                    value: 'AT'
                },
                {
                    label: "Azerbaijan",
                    value: 'AZ'
                },
                {
                    label: "Bahamas",
                    value: 'BS'
                },
                {
                    label: "Bahrain",
                    value: 'BH'
                },
                {
                    label: "Bangladesh",
                    value: 'BD'
                },
                {
                    label: "Barbados",
                    value: 'BB'
                },
                {
                    label: "Belarus",
                    value: 'BY'
                },
                {
                    label: "Belgium",
                    value: 'BE'
                },
                {
                    label: "Belau",
                    value: 'PW'
                },
                {
                    label: "Belize",
                    value: 'BZ'
                },
                {
                    label: "Benin",
                    value: 'BJ'
                },
                {
                    label: "Bermuda",
                    value: 'BM'
                },
                {
                    label: "Bhutan",
                    value: 'BT'
                },
                {
                    label: "Bolivia",
                    value: 'BO'
                },
                {
                    label: "Bonaire, Saint Eustatius and Saba",
                    value: 'BQ'
                },
                {
                    label: "Bosnia and Herzegovina",
                    value: 'BA'
                },
                {
                    label: "Botswana",
                    value: 'BW'
                },
                {
                    label: "Bouvet Island",
                    value: 'BV'
                },
                {
                    label: "Brazil",
                    value: 'BR'
                },
                {
                    label: "British Indian Ocean Territory",
                    value: 'IO'
                },
                {
                    label: "Brunei",
                    value: 'BN'
                },
                {
                    label: "Bulgaria",
                    value: 'BG'
                },
                {
                    label: "Burkina Faso",
                    value: 'BF'
                },
                {
                    label: "Burundi",
                    value: 'BI'
                },
                {
                    label: "Cambodia",
                    value: 'KH'
                },
                {
                    label: "Cameroon",
                    value: 'CM'
                },
                {
                    label: "Canada",
                    value: 'CA'
                },
                {
                    label: "Cape Verde",
                    value: 'CV'
                },
                {
                    label: "Cayman Islands",
                    value: 'KY'
                },
                {
                    label: "Central African Republic",
                    value: 'CF'
                },
                {
                    label: "Chad",
                    value: 'TD'
                },
                {
                    label: "Chile",
                    value: 'CL'
                },
                {
                    label: "China",
                    value: 'CN'
                },
                {
                    label: "Christmas Island",
                    value: 'CX'
                },
                {
                    label: "Cocos (Keeling) Islands",
                    value: 'CC'
                },
                {
                    label: "Colombia",
                    value: 'CO'
                },
                {
                    label: "Comoros",
                    value: 'KM'
                },
                {
                    label: "Congo (Brazzaville)",
                    value: 'CG'
                },
                {
                    label: "Congo (Kinshasa)",
                    value: 'CD'
                },
                {
                    label: "Cook Islands",
                    value: 'CK'
                },
                {
                    label: "Costa Rica",
                    value: 'CR'
                },
                {
                    label: "Croatia",
                    value: 'HR'
                },
                {
                    label: "Cuba",
                    value: 'CU'
                },
                {
                    label: "Curaçao",
                    value: 'CW'
                },
                {
                    label: "Cyprus",
                    value: 'CY'
                },
                {
                    label: "Czechia (Czech Republic)",
                    value: 'CZ'
                },
                {
                    label: "Denmark",
                    value: 'DK'
                },
                {
                    label: "Djibouti",
                    value: 'DJ'
                },
                {
                    label: "Dominica",
                    value: 'DM'
                },
                {
                    label: "Dominican Republic",
                    value: 'DO'
                },
                {
                    label: "Ecuador",
                    value: 'EC'
                },
                {
                    label: "Egypt",
                    value: 'EG'
                },
                {
                    label: "El Salvador",
                    value: 'SV'
                },
                {
                    label: "Eritrea",
                    value: 'ER'
                },
                {
                    label: "Estonia",
                    value: 'EE'
                },
                {
                    label: "Ethiopia",
                    value: 'ET'
                },
                {
                    label: "Falkland Islands",
                    value: 'FK'
                },
                {
                    label: "Faroe Islands",
                    value: 'FO'
                },
                {
                    label: "Fiji",
                    value: 'FJ'
                },
                {
                    label: "Finland",
                    value: 'FI'
                },
                {
                    label: "France",
                    value: 'FR'
                },
                {
                    label: "French Guiana",
                    value: 'GF'
                },
                {
                    label: "French Polynesia",
                    value: 'PF'
                },
                {
                    label: "French Southern Territories",
                    value: 'TF'
                },
                {
                    label: "Gabon",
                    value: 'GA'
                },
                {
                    label: "Georgia",
                    value: 'GE'
                },
                {
                    label: "Germany",
                    value: 'DE'
                },
                {
                    label: "Ghana",
                    value: 'GH'
                },
                {
                    label: "Gibraltar",
                    value: 'GI'
                },
                {
                    label: "Greece",
                    value: 'GR'
                },
                {
                    label: "Greenland",
                    value: 'GL'
                },
                {
                    label: "Grenada",
                    value: 'GD'
                },
                {
                    label: "Guadeloupe",
                    value: 'GP'
                },
                {
                    label: "Guam",
                    value: 'GU'
                },
                {
                    label: "Guatemala",
                    value: 'GT'
                },
                {
                    label: "Guernsey",
                    value: 'GG'
                },
                {
                    label: "Guinea",
                    value: 'GN'
                },
                {
                    label: "Guinea-Bissau",
                    value: 'GW'
                },
                {
                    label: "Guyana",
                    value: 'GY'
                },
                {
                    label: "Haiti",
                    value: 'HT'
                },
                {
                    label: "Heard Island and McDonald Islands",
                    value: 'HM'
                },
                {
                    label: "Honduras",
                    value: 'HN'
                },
                {
                    label: "Hong Kong",
                    value: 'HK'
                },
                {
                    label: "Hungary",
                    value: 'HU'
                },
                {
                    label: "Iceland",
                    value: 'IS'
                },
                {
                    label: "India",
                    value: 'IN'
                },
                {
                    label: "Indonesia",
                    value: 'ID'
                },
                {
                    label: "Iran",
                    value: 'IR'
                },
                {
                    label: "Iraq",
                    value: 'IQ'
                },
                {
                    label: "Ireland",
                    value: 'IE'
                },
                {
                    label: "Isle of Man",
                    value: 'IM'
                },
                {
                    label: "Israel",
                    value: 'IL'
                },
                {
                    label: "Italy",
                    value: 'IT'
                },
                {
                    label: "Ivory Coast",
                    value: 'CI'
                },
                {
                    label: "Jamaica",
                    value: 'JM'
                },
                {
                    label: "Japan",
                    value: 'JP'
                },
                {
                    label: "Jersey",
                    value: 'JE'
                },
                {
                    label: "Jordan",
                    value: 'JO'
                },
                {
                    label: "Kazakhstan",
                    value: 'KZ'
                },
                {
                    label: "Kenya",
                    value: 'KE'
                },
                {
                    label: "Kiribati",
                    value: 'KI'
                },
                {
                    label: "Kuwait",
                    value: 'KW'
                },
                {
                    label: "Kosovo",
                    value: 'XK'
                },
                {
                    label: "Kyrgyzstan",
                    value: 'KG'
                },
                {
                    label: "Laos",
                    value: 'LA'
                },
                {
                    label: "Latvia",
                    value: 'LV'
                },
                {
                    label: "Lebanon",
                    value: 'LB'
                },
                {
                    label: "Lesotho",
                    value: 'LS'
                },
                {
                    label: "Liberia",
                    value: 'LR'
                },
                {
                    label: "Libya",
                    value: 'LY'
                },
                {
                    label: "Liechtenstein",
                    value: 'LI'
                },
                {
                    label: "Lithuania",
                    value: 'LT'
                },
                {
                    label: "Luxembourg",
                    value: 'LU'
                },
                {
                    label: "Macao",
                    value: 'MO'
                },
                {
                    label: "North Macedonia",
                    value: 'MK'
                },
                {
                    label: "Madagascar",
                    value: 'MG'
                },
                {
                    label: "Malawi",
                    value: 'MW'
                },
                {
                    label: "Malaysia",
                    value: 'MY'
                },
                {
                    label: "Maldives",
                    value: 'MV'
                },
                {
                    label: "Mali",
                    value: 'ML'
                },
                {
                    label: "Malta",
                    value: 'MT'
                },
                {
                    label: "Marshall Islands",
                    value: 'MH'
                },
                {
                    label: "Martinique",
                    value: 'MQ'
                },
                {
                    label: "Mauritania",
                    value: 'MR'
                },
                {
                    label: "Mauritius",
                    value: 'MU'
                },
                {
                    label: "Mayotte",
                    value: 'YT'
                },
                {
                    label: "Mexico",
                    value: 'MX'
                },
                {
                    label: "Micronesia",
                    value: 'FM'
                },
                {
                    label: "Moldova",
                    value: 'MD'
                },
                {
                    label: "Monaco",
                    value: 'MC'
                },
                {
                    label: "Mongolia",
                    value: 'MN'
                },
                {
                    label: "Montenegro",
                    value: 'ME'
                },
                {
                    label: "Montserrat",
                    value: 'MS'
                },
                {
                    label: "Morocco",
                    value: 'MA'
                },
                {
                    label: "Mozambique",
                    value: 'MZ'
                },
                {
                    label: "Myanmar",
                    value: 'MM'
                },
                {
                    label: "Namibia",
                    value: 'NA'
                },
                {
                    label: "Nauru",
                    value: 'NR'
                },
                {
                    label: "Nepal",
                    value: 'NP'
                },
                {
                    label: "Netherlands",
                    value: 'NL'
                },
                {
                    label: "New Caledonia",
                    value: 'NC'
                },
                {
                    label: "New Zealand",
                    value: 'NZ'
                },
                {
                    label: "Nicaragua",
                    value: 'NI'
                },
                {
                    label: "Niger",
                    value: 'NE'
                },
                {
                    label: "Nigeria",
                    value: 'NG'
                },
                {
                    label: "Niue",
                    value: 'NU'
                },
                {
                    label: "Norfolk Island",
                    value: 'NF'
                },
                {
                    label: "Northern Mariana Islands",
                    value: 'MP'
                },
                {
                    label: "North Korea",
                    value: 'KP'
                },
                {
                    label: "Norway",
                    value: 'NO'
                },
                {
                    label: "Oman",
                    value: 'OM'
                },
                {
                    label: "Pakistan",
                    value: 'PK'
                },
                {
                    label: "Palestinian Territory",
                    value: 'PS'
                },
                {
                    label: "Panama",
                    value: 'PA'
                },
                {
                    label: "Papua New Guinea",
                    value: 'PG'
                },
                {
                    label: "Paraguay",
                    value: 'PY'
                },
                {
                    label: "Peru",
                    value: 'PE'
                },
                {
                    label: "Philippines",
                    value: 'PH'
                },
                {
                    label: "Pitcairn",
                    value: 'PN'
                },
                {
                    label: "Poland",
                    value: 'PL'
                },
                {
                    label: "Portugal",
                    value: 'PT'
                },
                {
                    label: "Puerto Rico",
                    value: 'PR'
                },
                {
                    label: "Qatar",
                    value: 'QA'
                },
                {
                    label: "Reunion",
                    value: 'RE'
                },
                {
                    label: "Romania",
                    value: 'RO'
                },
                {
                    label: "Russia",
                    value: 'RU'
                },
                {
                    label: "Rwanda",
                    value: 'RW'
                },
                {
                    label: "Saint Barthélemy",
                    value: 'BL'
                },
                {
                    label: "Saint Helena",
                    value: 'SH'
                },
                {
                    label: "Saint Kitts and Nevis",
                    value: 'KN'
                },
                {
                    label: "Saint Lucia",
                    value: 'LC'
                },
                {
                    label: "Saint Martin (French part)",
                    value: 'MF'
                },
                {
                    label: "Saint Martin (Dutch part)",
                    value: 'SX'
                },
                {
                    label: "Saint Pierre and Miquelon",
                    value: 'PM'
                },
                {
                    label: "Saint Vincent and the Grenadines",
                    value: 'VC'
                },
                {
                    label: "San Marino",
                    value: 'SM'
                },
                {
                    label: "SÃo Tomé and Príncipe",
                    value: 'ST'
                },
                {
                    label: "Saudi Arabia",
                    value: 'SA'
                },
                {
                    label: "Senegal",
                    value: 'SN'
                },
                {
                    label: "Serbia",
                    value: 'RS'
                },
                {
                    label: "Seychelles",
                    value: 'SC'
                },
                {
                    label: "Sierra Leone",
                    value: 'SL'
                },
                {
                    label: "Singapore",
                    value: 'SG'
                },
                {
                    label: "Slovakia",
                    value: 'SK'
                },
                {
                    label: "Slovenia",
                    value: 'SI'
                },
                {
                    label: "Somalia",
                    value: 'SO'
                },
                {
                    label: "South Africa",
                    value: 'ZA'
                },
                {
                    label: "South Georgia/Sandwich Islands",
                    value: 'GS'
                },
                {
                    label: "South Korea",
                    value: 'KR'
                },
                {
                    label: "South Sudan",
                    value: 'SS'
                },
                {
                    label: "Spain",
                    value: 'ES'
                },
                {
                    label: "Sri Lanka",
                    value: 'LK'
                },
                {
                    label: "Sudan",
                    value: 'SD'
                },
                {
                    label: "Suriname",
                    value: 'SR'
                },
                {
                    label: "Svalbard and Jan Mayen",
                    value: 'SJ'
                },
                {
                    label: "Swaziland",
                    value: 'SZ'
                },
                {
                    label: "Sweden",
                    value: 'SE'
                },
                {
                    label: "Switzerland",
                    value: 'CH'
                },
                {
                    label: "Syria",
                    value: 'SY'
                },
                {
                    label: "Taiwan",
                    value: 'TW'
                },
                {
                    label: "Tajikistan",
                    value: 'TJ'
                },
                {
                    label: "Tanzania",
                    value: 'TZ'
                },
                {
                    label: "Thailand",
                    value: 'TH'
                },
                {
                    label: "Timor-Leste",
                    value: 'TL'
                },
                {
                    label: "Togo",
                    value: 'TG'
                },
                {
                    label: "Tokelau",
                    value: 'TK'
                },
                {
                    label: "Tonga",
                    value: 'TO'
                },
                {
                    label: "Trinidad and Tobago",
                    value: 'TT'
                },
                {
                    label: "Tunisia",
                    value: 'TN'
                },
                {
                    label: "Turkey",
                    value: 'TR'
                },
                {
                    label: "Turkmenistan",
                    value: 'TM'
                },
                {
                    label: "Turks and Caicos Islands",
                    value: 'TC'
                },
                {
                    label: "Tuvalu",
                    value: 'TV'
                },
                {
                    label: "Uganda",
                    value: 'UG'
                },
                {
                    label: "Ukraine",
                    value: 'UA'
                },
                {
                    label: "United Arab Emirates",
                    value: 'AE'
                },
                {
                    label: "United Kingdom (UK)",
                    value: 'GB'
                },
                {
                    label: "United States (US)",
                    value: 'US'
                },
                {
                    label: "United States (US) Minor Outlying Islands",
                    value: 'UM'
                },
                {
                    label: "Uruguay",
                    value: 'UY'
                },
                {
                    label: "Uzbekistan",
                    value: 'UZ'
                },
                {
                    label: "Vanuatu",
                    value: 'VU'
                },
                {
                    label: "Vatican",
                    value: 'VA'
                },
                {
                    label: "Venezuela",
                    value: 'VE'
                },
                {
                    label: "Vietnam",
                    value: 'VN'
                },
                {
                    label: "Virgin Islands (British)",
                    value: 'VG'
                },
                {
                    label: "Virgin Islands (US)",
                    value: 'VI'
                },
                {
                    label: "Wallis and Futuna",
                    value: 'WF'
                },
                {
                    label: "Western Sahara",
                    value: 'EH'
                },
                {
                    label: "Samoa",
                    value: 'WS'
                },
                {
                    label: "Yemen",
                    value: 'YE'
                },
                {
                    label: "Zambia",
                    value: 'ZM'
                },
                {
                    label: "Zimbabwe",
                    value: 'ZW'
                }
            ],
            currency: '',
            currencies: [
                {
                    label: 'BDT',
                    value: 'bdt'
                },
                {
                    label: 'USD ($)',
                    value: 'usd'
                },
                {
                    label: 'EUR (€)',
                    value: 'eur'
                },
                {
                    label: 'GBP (£)',
                    value: 'gbp'
                },
                {
                    label: 'CAD (C$)',
                    value: 'cad'
                },
                {
                    label: 'AUD (A$)',
                    value: 'aud'
                },
                {
                    label: 'INR (₹)',
                    value: 'inr'
                },
                {
                    label: 'SEK (kr)',
                    value: 'sek'
                },
                {
                    label: 'PLN (zł)',
                    value: 'pln'
                },
                {
                    label: 'CHF',
                    value: 'chf'
                },
                {
                    label: 'DKK',
                    value: 'dkk'
                },
                {
                    label: 'NZD',
                    value: 'nzd'
                }
            ]
        }
    }
}
</script>